import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord, query } from '@warp-drive/utilities/json-api';
import type { PersonExtension as PersonModel } from 'tio-data/data/resources/person.ext';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import type { Store } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';
import { getLoanSummaryRequest } from 'tio-data/requests/user';

export default class AuthenticatedIdrDashboardIndexRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;

  async model() {
    const userId = this.sessionContext.user.id;
    const [loanSummaryResp, personResult, allRecsResult] = await Promise.all([
      userId
        ? this.store.request(getLoanSummaryRequest(userId))
        : Promise.resolve({ content: undefined }),
      this.store.request(
        findRecord<PersonModel>('person', this.sessionContext.user.person.id!, {
          include: 'accounts.financial-institution,accounts.loans',
          reload: true,
        })
      ) as Promise<{ content: { data: PersonModel } }>,
      this.store.request(
        query<RecommendationModel>('recommendation', {
          'filter[user]': userId,
          'filter[requesting-app]': 'IDR',
          include: 'user',
          sort: '-created-at',
          'page[offset]': 0,
          'page[limit]': 3,
        })
      ) as Promise<{ content: { data: RecommendationModel[] } }>,
    ]);

    const person = personResult.content.data;
    const allRecommendations = allRecsResult.content.data;

    // These are async: false relationships — data is already sideloaded via the include param
    const personAccounts = person.accounts;
    const user = person.user;

    return {
      accounts: personAccounts,
      allRecommendations,
      loanSummary: loanSummaryResp.content,
      mostRecentRecommendation: allRecommendations?.[0],
      person: person,
      user: user,
    };
  }
}
